import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import Hero from '@/pages/phoenix-lite-mentoring/components/Hero';
import Transformation from '@/pages/phoenix-lite-mentoring/components/Transformation';
import Method from '@/pages/phoenix-lite-mentoring/components/Method';
import Includes from '@/pages/phoenix-lite-mentoring/components/Includes';
import Bonuses from '@/pages/phoenix-lite-mentoring/components/Bonuses';
import Pricing from '@/pages/phoenix-lite-mentoring/components/Pricing';
import ForYou from '@/pages/phoenix-lite-mentoring/components/ForYou';
import AboutMentor from '@/pages/phoenix-lite-mentoring/components/AboutMentor';
import Results from '@/pages/phoenix-lite-mentoring/components/Results';
import FAQ from '@/pages/phoenix-lite-mentoring/components/FAQ';
import FinalCTA from '@/pages/phoenix-lite-mentoring/components/FinalCTA';

export default function PhoenixLiteMentoring() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Transformation />
        <Method />
        <Includes />
        <Bonuses />
        <Pricing />
        <ForYou />
        <AboutMentor />
        <Results />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}